import $ from 'jquery';

$('.mobile-expand')
  .find('.dropdown-menu')
  .each(function () {
    $(this).removeClass('peer-hover:flex peer-hover:flex-col').addClass('block');
  });

// $('.mobile-expand .dropdown-toggle').on('click', function () {
//   const isExpanded = $(this).attr('aria-expanded');
//   const expansion = isExpanded == 'false' || isExpanded == false ? true : false;

//   if (!expansion) {
//     $(this).trigger('blur');
//   } else {
//   }

//   $(this).attr('aria-expanded', expansion);
// });

// $('.mobile-expand .dropdown-toggle').on('blur', function () {
//   $(this).attr('aria-expanded', false);
// });
